import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackAuthenticateClick, trackPlaceOfferClick } from './tracking';
import { modalOpen } from '../../actions/authentication';
import { InvestorDayStreamButton } from '../../components/InvestorDayStreamButton';
import { UserRelated } from '../../components/UserRelated';
import { AUD_MOBILE_REDESIGN_MAINPAGE_HEADER } from '../../constants/experiments';
import { selectExperiments } from '../../selectors/experiments';
import { selectPageType } from '../../selectors/page';
import { selectShouldShowNewPlacementText, selectUser } from '../../selectors/user';
import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { TUserState } from '../../types/user';
import { useApplicationContext } from '../../utils/applicationContext';
import { getExperiment } from '../../utils/experiments';
import { AddOfferButtonContainer } from '../AddOfferButtonContainer';
import { CianGptButtonContainer } from '../CianGptButtonContainer';
import { UserContainer } from '../UserContainer';
import { UtilitiesContainer } from '../UtilitiesContainer';

export const UserRelatedContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch<TThunkDispatch>();
  const user = useSelector<IApplicationState, TUserState>(selectUser);
  const hasBlockedSanction = user.isAuthenticated ? user.hasBlockedSanction : false;
  const pageType = useSelector(selectPageType);
  const placeOfferLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.placeOffer);
  const shouldShowNewPlacementText = useSelector(selectShouldShowNewPlacementText);

  const isCianGptButtonEnabled = config.get<boolean>('header-frontend.cianGptButton.Enabled') ?? false;
  const investorDayLink = config.get<string>('BX.investorDayLink');

  const handlePlaceOfferClick = React.useCallback(() => trackPlaceOfferClick(pageType), [pageType]);
  const handleAuthenticateClick = React.useCallback(() => {
    dispatch(modalOpen());
    trackAuthenticateClick(pageType);
  }, [dispatch, pageType]);

  const experiments = useSelector(selectExperiments);
  const experimentGroup = getExperiment(experiments, AUD_MOBILE_REDESIGN_MAINPAGE_HEADER)?.group || null;

  return (
    <UserRelated
      gptButton={
        investorDayLink ? (
          <InvestorDayStreamButton link={investorDayLink} />
        ) : isCianGptButtonEnabled ? (
          <CianGptButtonContainer />
        ) : null
      }
      userMenu={user.isAuthenticated ? <UserContainer /> : null}
      utilities={<UtilitiesContainer />}
      placeOfferLink={placeOfferLink}
      addOfferButton={<AddOfferButtonContainer />}
      hasBlockedSanction={hasBlockedSanction}
      shouldShowNewPlacementText={shouldShowNewPlacementText}
      onPlaceOfferClick={handlePlaceOfferClick}
      onAuthenticateClick={handleAuthenticateClick}
      experimentGroup={experimentGroup}
    />
  );
};
